import { React, useState, useEffect } from 'react'
import { Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import dayjs from 'dayjs';
import { Toaster, toast } from 'react-hot-toast';
import SubmittingModal from 'components/Modal';
import { assignInventory } from 'actions/action';
import { updateAssignInventory } from 'actions/action';
import ImageCarouselInfo from 'components/ImageCarousalInfo';

export default function AssignCreateInventoryStudent() {

  // let getUserId = "";
  let viewFlag = false;

  const navigate = useNavigate();
  const location = useLocation();
  // const labId = location.state?.labId;
  const { type, item } = location.state;
  const [inventoryData, setInventoryData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  // let statusArray = [
  //   { id: 0, status: "Select Status" },
  //   { id: 1, status: "Issued" },
  //   { id: 2, status: "Received" },
  // ]

  if (window.location.href.includes('/assign-create-inventory/id:')) {
    let getExtractUrl = window.location.href.split('/assign-create-inventory/id:')[1];
    if (getExtractUrl) {
      let splitUrl = getExtractUrl.split('/viewFlag=');
      // getUserId = splitUrl[0] || "";
      viewFlag = splitUrl[1] === "true";
    }
  }
  const userId = localStorage.getItem("user_id");
  let [formData, setFormData] = useState({
    registration_id: 0,
    user_id: userId,
    inventory_id: item.id,
    issued_date: "",
    receiving_date: "",
    status: 1,
    quantity: 1
  })

  // Add maxAvailable and checkingAvailability states
  const [maxAvailable, setMaxAvailable] = useState(1);
  const [checkingAvailability, setCheckingAvailability] = useState(false);

  const formatDate = (date) => {
    return date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  let [error, setError] = useState({
    registration_id: "",
    user_id: "",
    inventory_id: "",
    issued_date: "",
    receiving_date: "",
    status: ""
  })

  useEffect(() => {
    // if (item.id) {
    //   getInventoryDataById(item.id);
    // }
    getUserDropdown();
    getInventoryDropdown();
  }, []);

  // Check availability when dates change
  useEffect(() => {
    if (formData.inventory_id && formData.issued_date && formData.receiving_date) {
      checkAvailability();
    }
  }, [formData.inventory_id, formData.issued_date, formData.receiving_date]);

  async function checkAvailability() {
    try {
      if (!formData.inventory_id || !formData.issued_date || !formData.receiving_date) return;

      setCheckingAvailability(true);
      const token = localStorage.getItem('token');
      // Format dates as YYYY-MM-DD for the API
      const issued = dayjs(formData.issued_date).format('YYYY-MM-DD HH:mm:ss');
      const receiving = dayjs(formData.receiving_date).format('YYYY-MM-DD HH:mm:ss');

      const response = await axios.get(`https://api.nvcti.in/api/inventory/registration/checkAvailability`, {
        params: {
          inventory_id: formData.inventory_id,
          issued_date: issued,
          receiving_date: receiving
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.data.success) {
        setMaxAvailable(response.data.available_quantity);
        // If current quantity is higher than available, reset to available (or 1)
        if (formData.quantity > response.data.available_quantity) {
          setFormData(prev => ({ ...prev, quantity: Math.max(1, response.data.available_quantity) }));
        }
      }

    } catch (error) {
      console.error("Error checking availability", error);
    } finally {
      setCheckingAvailability(false);
    }
  }


  function getFormValues(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: "" })
  }

  function validateForm() {
    let errors = {};
    let isValid = true;
    if (!formData.user_id) { errors.user_id = "User name is required"; isValid = false; }
    if (!formData.inventory_id) { errors.inventory_id = "Inventory name is required"; isValid = false; }
    if (!formData.issued_date) { errors.issued_date = "Issued date is required"; isValid = false; }
    if (!formData.receiving_date) { errors.receiving_date = "Received date is required"; isValid = false; }
    if (!formData.status) { errors.status = "Status is required"; isValid = false; }
    setError(errors);
    return isValid;
  }

  async function getInventoryDropdown() {
    try {
      const token = localStorage.getItem('token');
      const getApiResponse = await axios.get("https://api.nvcti.in/api/inventory/getAllInventories", {
        // const getApiResponse = await axios.get("https://api.nvcti.in/api/inventory/getAllInventories", {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      })
      if (getApiResponse.status == 200) {
        setInventoryData(getApiResponse.status == 200 ? getApiResponse.data : []);
      } else {
        setInventoryData([]);
      }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setInventoryData([]);
    }
  }

  async function getUserDropdown() {
    try {
      const token = localStorage.getItem('token');
      const getApiResponse = await axios.get("https://api.nvcti.in/user/getAllUsers", {
        // const getApiResponse = await axios.get("https://api.nvcti.in/user/getAllUsers", {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      })
      if (getApiResponse.status == 200) {
        setUserData(getApiResponse.data.data);
      } else {
        setUserData([]);
      }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setUserData([]);
    }
  }

  // const loadInventoryOptions = async (inputValue, callback) => {
  //   try {
  //     if (!inventoryData.length) {
  //       await getInventoryDropdown();
  //     }
  //     const filteredOptions = inventoryData
  //       .filter((item) =>
  //         item.name.toLowerCase().includes(inputValue.toLowerCase())
  //       )
  //       .map((item) => ({
  //         value: item.id,
  //         label: item.name,
  //       }));

  //     callback(filteredOptions);
  //   } catch (error) {
  //     toast.error("Error loading inventory options:", error);
  //     callback([]);
  //   }
  // };

  // const loadUserOptions = async (inputValue, callback) => {
  //   try {
  //     if (!userData.length) {
  //       await getUserDropdown();
  //     }
  //     const filteredOptions = userData
  //       .filter((user) =>
  //         user.first_name.toLowerCase().includes(inputValue.toLowerCase())
  //       )
  //       .map((user) => ({
  //         value: user.user_id,
  //         label: user.first_name,
  //       }));

  //     callback(filteredOptions);
  //   } catch (error) {
  //     toast.error("Error loading user options:", error);
  //     callback([]);
  //   }
  // };


  // async function getInventoryDataById(id) {
  //   try {
  //     const token = localStorage.getItem('token');
  //     let response = await axios.get("https://api.nvcti.in/api/inventory/registration/getInventoryRegistrationById/" + id,
  //     // let response = await axios.get("https://api.nvcti.in/api/inventory/registration/getInventoryRegistrationById/" + id,
  //       {
  //         headers: {
  //           "Authorization": `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     setFormData({
  //       registration_id: response.data.registration_id || "",
  //       user_id: response.data.user_id || "",
  //       inventory_id: response.data.inventory_id || "",
  //       issued_date: response.data.issued_date ? dayjs(response.data.issued_date).format("YYYY-MM-DD") : "",
  //       receiving_date: response.data.receiving_date ? dayjs(response.data.receiving_date).format("YYYY-MM-DD") : "",
  //       status: response.data.status == "issued" ? 1 : 2
  //     });
  //     console.log("a", response.data);
  //   } catch (error) {
  //     alert(error.response?.data?.message || "Something went wrong");
  //   }
  // }

  async function onSubmitFormData(e) {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      setLoading(true);
      const data = {
        registration_id: formData.registration_id || 0,
        user_id: Number(formData.user_id),
        inventory_id: Number(formData.inventory_id),
        issued_date: formatDate(formData.issued_date),
        receiving_date: formatDate(formData.receiving_date),
        quantity: formData.quantity || 1
        // status: formData.status === 1 ? 'issued' : 'received'
      }
      const responseData = type === "create" ? await assignInventory(data) : await updateAssignInventory(data, data.registration_id);
      toast.success(!(type === "edit") ? "Inventory Assign successfully!" : "Inventory Update successfully!");
      //setFormData({ user_id: "", inventory_id: "", issued_date: "", receiving_date: "", status: "" });
      navigate(`/student/inventory/labs/${item.lab_id}`);
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  function clearFormData() {
    setFormData({ user_id: "", inventory_id: "", issued_date: "", receiving_date: "", status: "" });
    setError({ user_id: "", inventory_id: "", issued_date: "", receiving_date: "", status: "" })
  }

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <SubmittingModal loading={loading} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-transparent border-0">
          <div className="rounded-t bg-transparent mb-0 px-6 py-6 border-b border-blueGray-600">
            <div className="text-center flex justify-between">
              <h6 className="text-white text-xl font-semibold">
                {!viewFlag ? 'Register for Inventory' : 'View Inventory'}
              </h6>
              <Tooltip title="View Applied Registrations" arrow>
                <button
                  className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/student/viewInvRegistration`, { state: { invId: item.id } });
                  }}>
                  View Registrations
                </button>
              </Tooltip>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form onSubmit={onSubmitFormData}>

              <h6 className="text-white text-xl mt-3 mb-6 font-semibold "> Description</h6>
              <div className="flex flex-wrap">
                <div className='flex justify-center w-full mb-3' >
                  <ImageCarouselInfo images={item.inventory_images} />
                </div>
                <div className="w-full lg:w-6/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-white w-40 capitalize">Name :</span>
                    <span className="text-white"> {item.name} </span>
                  </div>
                </div>

                {item.description && (
                  <div className="w-full lg:w-12/12" >
                    <div className="relative w-full mb-3">
                      <span className="font-bold text-white w-40 capitalize">Description :</span>
                      <span className="text-white"> {item.description} </span>
                    </div>
                  </div>
                )}
              </div>
              <hr className='mt-3 border-b-1 border-blueGray-600' />
              <h6 className="text-white text-xl mt-3 mb-6 font-semibold ">{!viewFlag ? 'Inventory Information' : 'View Inventory'}</h6>

              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Request Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      disabled={viewFlag}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="date"
                      name="issued_date"
                      value={formData.issued_date}
                      onChange={getFormValues}
                    />
                    {error.issued_date && <p className="text-red-500 text-xs mt-1">{error.issued_date}</p>}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Tentative Return Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      disabled={viewFlag}
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      type="date"
                      name="receiving_date"
                      value={formData.receiving_date}
                      onChange={getFormValues}
                    />
                    {error.receiving_date && <p className="text-red-500 text-xs mt-1">{error.receiving_date}</p>}
                  </div>
                </div>

              </div>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Quantity {checkingAvailability && "(Checking...)"} {maxAvailable !== null && !checkingAvailability && `(Max: ${maxAvailable})`} <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.quantity}
                      onChange={(e) => getFormValues(e)}
                      name="quantity"
                      disabled={viewFlag || checkingAvailability}
                    >
                      {Array.from({ length: Math.max(1, maxAvailable) }, (_, i) => i + 1).map(num => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                    {error.quantity && (
                      <p className="text-red-500 text-xs mt-1">{error.quantity}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(-1);
                      // navigate("/admin/assign-inventory");
                    }} >
                    {"<< "}Back
                  </button>
                </Tooltip>
                {!viewFlag ?
                  <>
                    <Tooltip title="Submit" arrow>
                      <button
                        className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="submit" >
                        {!(type === "edit") ? 'Submit' : 'Update'}
                      </button>
                    </Tooltip>
                    <Tooltip title="Clear" arrow>
                      <button
                        className="bg-red-500 mt-10 text-white active:bg-lightBlue-600 font-semibold  text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          clearFormData()
                        }} >
                        Clear
                      </button>
                    </Tooltip>
                  </>
                  : ""}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
